import React, { useState } from "react"

function Footer() {
    const [hovered, setHovered] = useState(false)

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }

    return (
        <>
            <style>{`
                .footer {
                    width: 100%;
                    background-color: #fff;
                    padding: 28px 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 14px;
                }
                .copyright {
                    font-size: 0.72rem;
                    font-family: 'Fanwood', serif;
                    letter-spacing: 0.08em;
                    text-transform: uppercase;
                    color: #888;
                }
                .back-to-top-btn {
                    cursor: pointer;
                    border: 1.5px solid black;
                    border-radius: 999px;
                    font-family: 'Fanwood', serif;
                    font-size: 13px;
                    font-weight: normal;
                    letter-spacing: 0.1em;
                    text-transform: uppercase;
                    padding: 8px 22px;
                    transition: background 0.22s cubic-bezier(0.16,1,0.3,1), color 0.22s cubic-bezier(0.16,1,0.3,1);
                    outline: none;
                    line-height: 1;
                    -webkit-tap-highlight-color: transparent;
                    touch-action: manipulation;
                }
                @media (max-width: 767px) {
                    .footer { padding: 20px 16px; }
                    .back-to-top-btn { font-size: 12px; padding: 7px 18px; }
                    .copyright { font-size: 0.65rem; }
                }
            `}</style>
            <footer className="footer">
                <button
                    className="back-to-top-btn"
                    onClick={scrollToTop}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    style={{
                        background: hovered ? "#000" : "transparent",
                        color: hovered ? "#fff" : "#000",
                    }}
                >
                    ↑ Back to Top
                </button>
                <div className="copyright">
                    © {new Date().getFullYear()} Sam Gaston. All rights reserved.
                </div>
            </footer>
        </>
    )
}

export default Footer
